import { select, call, put, takeLatest } from 'redux-saga/effects'
import { defineTypes } from '../helpers'
import AccountingEndpoint from '../persistence/AccountingEndpoint'
import { reduxFetch } from '../http/reduxFetch'
import moment from 'moment'

const accountingTypes = { ...defineTypes('ACCOUNTING')  }
const totalsTypes = { ...defineTypes('ACCOUNTING/TOTALS')  }
const timeSeriesTypes = { ...defineTypes('TIME_SERIES')  }
const tipsTypes = { ...defineTypes('TIPS')  }

export const initialState = {
  loading: false,
  loaded: false,
  range: 'month',
  timeSeries: [],
  totals: {},
  accounting: [],
  tips: [],
  startDate: moment().subtract(5, 'days'),
  endDate: moment()
}

export const actions = {
  setStartDate (date) {
    return { type: 'SET_START_DATE', date: date }
  },
  setEndDate (date) {
    return { type: 'SET_END_DATE', date: date }
  },
  getAccounting () {
    return { type: accountingTypes.REQUEST }
  },
  getTimeSeries () {
    return { type: timeSeriesTypes.REQUEST }
  },
  getTotals () {
    return { type: totalsTypes.REQUEST }
  },
  getTips () {
    return { type: tipsTypes.REQUEST }
  },
  setRange (value) {
    return { type: 'SET_RANGE', value: value['value'] }
  }
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_START_DATE':
      return { ...state, started: true, loading: true, startDate: action.date }
    case 'SET_END_DATE':
      return { ...state, started: true, loading: true, endDate: action.date }
    case accountingTypes.REQUEST:
      return { ...state, started: true, loading: true }
    case accountingTypes.SUCCESS:
      return { ...state, loading: false, loaded: true, accounting: action.accounting }
    case accountingTypes.DESTROY:
      return { ...state, loading: false }
    case accountingTypes.FAILURE:
      return { ...state, loading: false }
    case tipsTypes.REQUEST:
      return { ...state, started: true, loading: true }
    case tipsTypes.DESTROY:
      return { ...state, loading: false }
    case tipsTypes.FAILURE:
      return { ...state, loading: false }
    case tipsTypes.SUCCESS:
      return { ...state, loading: false, loaded: true, tips: action.tips }
    case timeSeriesTypes.REQUEST:
      return { ...state, started: true, loading: true }
    case timeSeriesTypes.DESTROY:
      return { ...state, loading: false }
    case timeSeriesTypes.FAILURE:
      return { ...state, loading: false }
    case timeSeriesTypes.SUCCESS:
      return { ...state, loading: false, loaded: true, timeSeries: action.timeSeries }
    case totalsTypes.REQUEST:
      return { ...state, started: true, loading: true }
    case totalsTypes.DESTROY:
      return { ...state, loading: false }
    case totalsTypes.FAILURE:
      return { ...state, loading: false }
    case totalsTypes.SUCCESS:
      return { ...state, loading: false, loaded: true, totals: action.totals }
    case 'SET_RANGE':
      return { ...state, range: action.value }
    default:
      return state
  }
}
export const selectors = {
  accounting: (store) => {
    return store['accounting'] && store['accounting']['accounting']
  },
  time_series: (store) => {
    return store['accounting'] && store['accounting']['timeSeries']
  },
  timeSeriesLoaded: (store) => {
    return store['accounting'] && store['accounting']['loaded']
  },
  totals: (store) => {
    return store['accounting'] && store['accounting']['totals']
  },
  tips: (store) => {
    return store['accounting'] && store['accounting']['tips']
  },
  range: (store) => {
    return store['accounting'] && store['accounting']['range']
  },
  endDate: (store) => {
    return store['accounting'] && store['accounting']['endDate']
  },
  startDate: (store) => {
    return store['accounting'] && store['accounting']['startDate']
  }
}

export function * tipsSaga () {
  try {
    let range = yield select(selectors.range)
    let startDate = yield select(selectors.startDate)
    let endDate = yield select(selectors.endDate)
    const response = yield call(reduxFetch, AccountingEndpoint.tips(range, startDate.toISOString(), endDate.toISOString()))
    yield put({ type: tipsTypes.SUCCESS, tips: response.data })
  } catch (error) {
    yield put({ type: tipsTypes.FAILURE, error })
  }
}

export function * accountingSaga () {
  try {
    let range = yield select(selectors.range)
    let startDate = yield select(selectors.startDate)
    let endDate = yield select(selectors.endDate)
    const response = yield call(reduxFetch, AccountingEndpoint.index(range, startDate.toISOString(), endDate.toISOString()))
    yield put({ type: accountingTypes.SUCCESS, accounting: response.data })
  } catch (error) {
    yield put({ type: accountingTypes.FAILURE, error })
  }
}

export function * timeSeriesSaga () {
  try {
    let range = yield select(selectors.range)
    let startDate = yield select(selectors.startDate)
    let endDate = yield select(selectors.endDate)
    const time_series_response = yield call(reduxFetch, AccountingEndpoint.time_series(range, startDate.toISOString(), endDate.toISOString()))
    yield put({ type: timeSeriesTypes.SUCCESS, timeSeries: time_series_response.data })
  } catch (error) {
    yield put({ type: accountingTypes.FAILURE, error })
  }
}

export function * totalsSaga () {
  try {
    let range = yield select(selectors.range)
    let startDate = yield select(selectors.startDate)
    let endDate = yield select(selectors.endDate)
    const totals_response = yield call(reduxFetch, AccountingEndpoint.totals(range, startDate.toISOString(), endDate.toISOString()))
    yield put({ type: totalsTypes.SUCCESS, totals: totals_response.data })
  } catch (error) {
    yield put({ type: accountingTypes.FAILURE, error })
  }
}

export function * rootSaga () {
  yield takeLatest(['SET_RANGE', accountingTypes.REQUEST], accountingSaga)
  yield takeLatest(['SET_RANGE', timeSeriesTypes.REQUEST], timeSeriesSaga)
  yield takeLatest(['SET_RANGE', totalsTypes.REQUEST], totalsSaga)
  yield takeLatest(['SET_RANGE', tipsTypes.REQUEST], tipsSaga)
  yield takeLatest(['SET_END_DATE', accountingTypes.REQUEST], accountingSaga)
  yield takeLatest(['SET_END_DATE', timeSeriesTypes.REQUEST], timeSeriesSaga)
  yield takeLatest(['SET_END_DATE', totalsTypes.REQUEST], totalsSaga)
  yield takeLatest(['SET_END_DATE', tipsTypes.REQUEST], tipsSaga)
  yield takeLatest(['SET_START_DATE', accountingTypes.REQUEST], accountingSaga)
  yield takeLatest(['SET_START_DATE', timeSeriesTypes.REQUEST], timeSeriesSaga)
  yield takeLatest(['SET_START_DATE', totalsTypes.REQUEST], totalsSaga)
  yield takeLatest(['SET_START_DATE', tipsTypes.REQUEST], tipsSaga)
}



// WEBPACK FOOTER //
// ./src/sagas/accounting.js